module.exports = __webpack_public_path__ + "img/diners-card.bbb76ffb.png";